export default __webpack_public_path__ + "static/media/hotei14.c0e51a62.webp";